module.exports = __webpack_public_path__ + "media/assets/images/blog/floppy-2e1b283dfcb0a60091d90a214902b16b.jpg";